import './component.scss';
import { Controller } from '@hotwired/stimulus';
import { application } from 'src/app';
import { getParent } from '@fretadao/f-js-dom';

application.register('search-filter', class extends Controller {
  static targets = ['menu'];

  connect() {
    if (this.hasMenuTarget) {
      this.menuTarget.style.width = window.getComputedStyle(getParent(this.menuTarget, 2)).width;
    }
  }
});
